import Layout from '../components/layout/Layout'
import SelfService from '../components/SelfService/SelfService'

const SelfServicePage = () => {
  return (
    <Layout>
      <SelfService />
    </Layout>
  )
}

export default SelfServicePage
